__turbopack_context__.v({
  "content": "Layout-module__jbLzUW__content",
  "editorContainer": "Layout-module__jbLzUW__editorContainer",
  "editorWithTerminal": "Layout-module__jbLzUW__editorWithTerminal",
  "layout": "Layout-module__jbLzUW__layout",
  "main": "Layout-module__jbLzUW__main",
});
